import { createWeb3JsRpc } from './createWeb3JsRpc.mjs';

function web3JsRpc(endpointOrConnection, rpcOptions) {
  return {
    install(umi) {
      umi.rpc = typeof endpointOrConnection === 'string' ? createWeb3JsRpc(umi, endpointOrConnection, rpcOptions) : createWeb3JsRpc(umi, endpointOrConnection);
    }
  };
}

export { web3JsRpc };
//# sourceMappingURL=plugin.mjs.map
